<template>
  <el-table
    :data="tableData"
    border
    stripe
    style="width: 100%; max-width: 800px; margin: 0 auto"
  >

    <el-table-column prop="parameter" label="配置说明" align="center" />
    <el-table-column prop="specification" label="规格内容" align="center" />
  </el-table>
</template>

<script setup>
import { ref } from 'vue';

const tableData = ref([
  { parameter: '电源功率', specification: '220V 50HZ 1200W' },
  { parameter: '机器重量', specification: '700KG' },
  { parameter: '转盘直径', specification: '1650mm' },
  { parameter: '转盘最大承重', specification: '2000kg' },
  { parameter: '转盘离地高度', specification: '80mm' },
  { parameter: '转盘转速', specification: '0—12r/min' },
  { parameter: '外型尺寸', specification: '2750mm*1650mm*2500mm' },
  { parameter: '升降速度', specification: '0 - 5m/min' },
  { parameter: '检测物品最大尺寸', specification: '1200mm*1200mm*2000mm' },
]);
</script>

<style scoped>
.el-table {
  margin-top: 20px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.el-table th {
  background-color: #f5f7fa;
  color: #303133;
  font-weight: 600;
}

.el-table td {
  color: #606266;
}
</style>  